import * as ReactDOM from "react-dom";
import * as React from "react";
import 'react-app-polyfill/ie11';
import {BigCalendar} from "./components/BigCalendar";
import {ListCalendar} from "./components/ListCalendar";
import ReadButton from "./components/ReadButton";
import ReadButtonList from "./components/ReadButtonList";

(window as any).react = {

    react_render_read_button: function (target: any, text: string, tag: string, done: boolean, timestamp: number) {
        if (target) {
            ReactDOM.render(<ReadButton text={text} tag={tag} done={done} timestamp={timestamp}/>, target);
        } else {
            console.error("target not found");
        }
    },

    react_render_read_buttons: function (target: any) {
        if (target) {
            ReactDOM.render(<ReadButtonList/>, target);
        } else {
            console.error("target not found");
        }
    },

    react_render_calendar: function (target: any, events: any, calendarId: string, guid: string, showDetails: boolean) {
        if (target) {
            ReactDOM.render(<BigCalendar
                events={events} calendarId={calendarId} showDetails={showDetails}
            />, target);
        } else {
            console.error("target not found");
        }
    },

    react_render_list_calendar: function (target: any, events: any, calendarId: string) {
        if (target) {
            ReactDOM.render(<ListCalendar
                events={events} calendarId={calendarId}
            />, target);
        } else {
            console.error("target not found");
        }
    }
}
